<template>
  <v-row dense no-gutters class="fill-height mt-2">
    <v-col cols="10" class="pa-1">
      <v-system-bar color="primary" dark>
        <span class="text-center white--text"> Показатели качества компонентов</span>
      </v-system-bar>
      <v-card flat outlined class="pr-3">
        <tbl-calculation-lab-data :components="COMPONENTS" />
      </v-card>
    </v-col>
    <v-col cols="2" class="pa-1">
      <v-system-bar color="primary" dark>
        <span class="text-center white--text"> Задание из конфигурации {{receipt.ULF_NAME}}</span>
      </v-system-bar>
      <v-card flat outlined class="pl-3">
        <tbl-calculation-rcp-limits :recepture="receipt" />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { dtUtilsMixin } from '@/components/modules/mixins/datetimeUtils'
import TblCalculationLabData from '../tables/tblCalculationLabData.vue'
import TblCalculationRcpLimits from '../tables/tblCalculationRcpLimits.vue'
export default {
  name: 'rcptLabDataPanel',
  mixins: [dtUtilsMixin],
  props: {
    receipt: {
      type: Object,
      default: function () {
        return {}
      }
    },
    activeTab: {
      type: String,
      default: null
    }
  },
  emits: ['onChange'],
  components: { TblCalculationRcpLimits, TblCalculationLabData },
  data () {
    return {}
  },
  computed: {
    COMPONENTS: {
      get () {
        return this.receipt.COMPONENTS
      }
    }
  },
  watch: {
    activeTab (val) {
      console.log('rcptLabDataPanel activeTab changed to ', val)
    }
  },
  methods: {
    onChangeReceipt (val) {
      this.$emit('onChange', val)
    }
  },
  mounted () {
    console.log('rcptLabDataPanel mounted with project ', this.receipt)
  }
}
</script>
